(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centered-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class CenteredProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.viewport = this.querySelector('.centered-product-carousel__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      if (!this.track || !this.viewport || this.slides.length === 0) {
        return;
      }

      this.activeIndex = Math.min(2, this.slides.length - 1);
      this.dragOffset = 0;
      this.pointerStart = 0;
      this.isDragging = false;
      this.wheelTimeout = null;
      this.autoplayTimer = null;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;

      this.setHeight();
      this.render();
      this.bindEvents();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      window.removeEventListener('resize', this.boundResize);
    }

    bindEvents() {
      this.boundResize = () => {
        this.setHeight();
        this.render();
      };

      window.addEventListener('resize', this.boundResize);

      this.previousButton?.addEventListener('click', () => this.move(-1));
      this.nextButton?.addEventListener('click', () => this.move(1));

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      });

      this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event));
      this.viewport.addEventListener('wheel', (event) => this.onWheel(event), { passive: false });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.slides.forEach((slide) => {
        slide.addEventListener('click', (event) => {
          const index = Number(slide.dataset.index);

          if (index !== this.activeIndex) {
            event.preventDefault();
            this.goTo(index);
          }
        });
      });
    }

    setHeight() {
      const maxScale = Number(getComputedStyle(this).getPropertyValue('--carousel-center-scale')) || 1;
      const firstSlide = this.slides[0];

      if (!firstSlide) {
        return;
      }

      const width = firstSlide.getBoundingClientRect().width;
      const ratio = Number(getComputedStyle(this).getPropertyValue('--carousel-image-ratio')) || 1;
      const metaHeight = firstSlide.querySelector('.centered-product-carousel__meta')?.getBoundingClientRect().height || 54;
      const height = width / ratio * maxScale + metaHeight + 28;

      this.viewport.style.setProperty('--carousel-height', `${Math.ceil(height)}px`);
    }

    getStep() {
      const gap = parseFloat(getComputedStyle(this).getPropertyValue('--carousel-gap')) || 0;
      const width = this.slides[0]?.getBoundingClientRect().width || 0;

      return width + gap;
    }

    getScale(distance) {
      const style = getComputedStyle(this);
      const centerScale = Number(style.getPropertyValue('--carousel-center-scale')) || 1;
      const adjacentScale = Number(style.getPropertyValue('--carousel-adjacent-scale')) || 0.8;
      const outerScale = Number(style.getPropertyValue('--carousel-outer-scale')) || 0.65;

      if (distance <= 0) {
        return centerScale;
      }

      if (distance < 1) {
        return centerScale - ((centerScale - adjacentScale) * distance);
      }

      if (distance < 2) {
        return adjacentScale - ((adjacentScale - outerScale) * (distance - 1));
      }

      return outerScale;
    }

    getCircularOffset(index) {
      const total = this.slides.length;
      let offset = index - this.activeIndex;

      if (offset > total / 2) {
        offset -= total;
      }

      if (offset < total / -2) {
        offset += total;
      }

      return offset;
    }

    render() {
      const step = this.getStep();
      const progress = step ? this.dragOffset / step : 0;
      const visibleRange = Math.max(2, Math.ceil((Number(getComputedStyle(this.viewport).getPropertyValue('--carousel-visible-desktop')) || 5) / 2) + 1);

      this.slides.forEach((slide) => {
        const baseOffset = this.getCircularOffset(Number(slide.dataset.index));
        const offset = baseOffset + progress;
        const distance = Math.abs(offset);
        const scale = this.getScale(distance);
        const isVisible = distance <= visibleRange;

        slide.style.transform = `translateX(calc(-50% + ${offset * step}px)) scale(${scale})`;
        slide.style.opacity = isVisible ? '1' : '0';
        slide.style.zIndex = String(10 - Math.round(distance * 2));
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        slide.classList.toggle('is-active', distance < 0.5);
        slide.classList.toggle('is-adjacent', distance >= 0.5 && distance < 1.5);
        slide.classList.toggle('is-outer', distance >= 1.5 && distance < 2.5);

        const link = slide.querySelector('[data-carousel-link]');
        if (link) {
          link.tabIndex = distance < 0.5 ? 0 : -1;
        }
      });
    }

    move(direction) {
      this.goTo(this.normalizeIndex(this.activeIndex + direction));
    }

    goTo(index) {
      this.activeIndex = this.normalizeIndex(index);
      this.dragOffset = 0;
      this.render();
    }

    normalizeIndex(index) {
      const total = this.slides.length;

      return ((index % total) + total) % total;
    }

    onPointerDown(event) {
      if (event.button !== 0) {
        return;
      }

      this.isDragging = true;
      this.pointerStart = event.clientX;
      this.dragOffset = 0;
      this.stopAutoplay();
      this.viewport.setPointerCapture(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.isDragging) {
        return;
      }

      this.dragOffset = event.clientX - this.pointerStart;
      this.render();
    }

    onPointerUp(event) {
      if (!this.isDragging) {
        return;
      }

      const step = this.getStep();
      const threshold = Math.max(40, step * 0.18);
      const movement = event.clientX - this.pointerStart;

      this.isDragging = false;

      if (Math.abs(movement) > threshold) {
        this.move(movement < 0 ? 1 : -1);
      } else {
        this.dragOffset = 0;
        this.render();
      }

      this.startAutoplay();
    }

    onWheel(event) {
      const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;

      if (Math.abs(delta) < 8) {
        return;
      }

      event.preventDefault();
      this.stopAutoplay();
      this.dragOffset = -delta;
      this.render();

      window.clearTimeout(this.wheelTimeout);
      this.wheelTimeout = window.setTimeout(() => {
        this.move(delta > 0 ? 1 : -1);
        this.startAutoplay();
      }, 90);
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.autoplayTimer || this.matches(':hover') || this.contains(document.activeElement)) {
        return;
      }

      this.autoplayTimer = window.setInterval(() => this.move(1), this.autoplaySpeed);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  if (!customElements.get('centered-product-carousel')) {
    customElements.define('centered-product-carousel', CenteredProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
